import { render, staticRenderFns } from "./OpeningDuelTable.vue?vue&type=template&id=30e964d5&scoped=true&"
import script from "./OpeningDuelTable.vue?vue&type=script&lang=js&"
export * from "./OpeningDuelTable.vue?vue&type=script&lang=js&"
import style0 from "./OpeningDuelTable.vue?vue&type=style&index=0&id=30e964d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e964d5",
  null
  
)

export default component.exports